import React, { useEffect, useState } from 'react';
import file from './PDF.pdf'
import axios from 'axios';
import Web3 from 'web3';
import { Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import girl from './images/girl.jpeg'
import logo from './images/White.png'

function App() {

  const [isPopupOpen, setPopupOpen] = useState(true);
  const [NotBuyer, setNotBuyer] = useState(false);
  const [wallet, setWallet] = useState(null);

  const connectWallet = async () => {
    try {
      // Check if the user has MetaMask installed
      if (window.ethereum) {
        // Request access to the user's wallet
        await window.ethereum.request({ method: 'eth_requestAccounts' });

        // Create a Web3 instance using the injected provider (MetaMask)
        const web3Instance = new Web3(window.ethereum);
        // // Get the signer (account) from the provider
        const accountsList = await web3Instance.eth.getAccounts();

        // // Set the wallet in the component state
        setWallet(accountsList[0].toLowerCase());
      } else {
        // If MetaMask is not installed, display an error message
        console.error('MetaMask not detected. Please install MetaMask to use this DApp.');
      }
    } catch (error) {
      console.error('Error connecting wallet:', error.message);
    }
  };

  useEffect(() => {
    if (wallet) {
      console.log(wallet)
      axios.get('https://qr-code-api.oasisx.world/NFTgated', {
        params: {
          walletAddress: wallet,
          // walletAddress: "0xccd4cdb106266845a737b8f5bed30652b738f9ba",
          contractAddress: "0xacf1edff8f47c6d22d141ead76f0612bf7b74fde"
        }
      })
        .then(response => {
          console.log(response.data.verify);
          if (response.data.verify) {
            setPopupOpen(false);
          } else {
            setPopupOpen(false);
            setNotBuyer(true)
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  }, [wallet])
  return (
    <div >
      {!isPopupOpen && !NotBuyer ?
        <div style={{ height: '925px', }}>
          <Viewer fileUrl={file} />;
        </div>
        :
        <div>
          <img src={girl} alt='alt' style={{ height: '99.6vh', width: '100vw', objectFit: 'cover' }} />
        </div>
      }
      {isPopupOpen && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.9)', // Adjust the opacity for the desired blur effect
            zIndex: 1, // Ensure the popup is above other content
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div style={{ width: '600px', padding: '20px 40px 0px 40px', background: 'white', zIndex: 2, textAlign: 'center', borderRadius: '8px' }}>
            <h2 style={{ fontFamily: 'Cabin, sans-serif' }}>Welcome to your premium access to AFWME fashion trend report. To access the report you need to be a holder of our first NFT-AFWME 1.0 Human insights innovation</h2>
            <a href={`https://oasisx.world/collection/3871988e-4664-471f-a788-f88dbe24daf3`} style={{ fontFamily: "sans-serif" }} ><h3 style={{ lineHeight: '1.5' }}>Mint your NFT here to access the report</h3></a>
            <button style={{ width: '150px', padding: '10px 10px', margin: '15px', backgroundColor: '#0f72e5', borderRadius: '10px', color: '#ffffff', border: 'none' }} onClick={connectWallet}><span style={{ fontFamily: 'Cabin, sans-serif', fontSize: '20px' }}>Connect Wallet</span></button>
            <center>
              <div className="logo">
                <img src={logo} alt="" width={150} height={80} />
              </div>
            </center>
          </div>
        </div>
      )}
      {NotBuyer && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.9)', // Adjust the opacity for the desired blur effect
            zIndex: 1, // Ensure the popup is above other content
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div style={{ width: '420px', padding: '30px 40px', background: 'white', zIndex: 2, textAlign: 'center', fontFamily: 'Poppins, sans-serif', borderRadius: '8px' }}>
            <div style={{ fontFamily: "sans-serif" }} ><h3 style={{ lineHeight: '1.5' }}>Only holders of "AFWME 1.0 Human Insights" NFT can access this report</h3></div>
            <a href={`https://oasisx.world/collection/3871988e-4664-471f-a788-f88dbe24daf3`} style={{ fontFamily: "sans-serif" }} ><h3 style={{ lineHeight: '1.5' }}>Mint your NFT here to access the report</h3></a>

          </div>
        </div>
      )}

    </div>
  );

}

export default App;
